<ng-template #showIcon>
  <fcom-icon *ngIf="icon; else returnBtn" [ngClass]="fullScreen ? 'icon-large' : 'icon-medium'" [name]="icon" />
</ng-template>
<ng-template #emptyIcon>
  <fcom-icon *ngIf="!icon && (stepperSteps$ | async)" [name]="SvgLibraryIcon.EMPTY" />
</ng-template>
<ng-template #returnBtn>
  <button
    [attr.aria-label]="'actions.back' | finLocalization"
    [attr.title]="'actions.back' | finLocalization"
    (click)="returnClicked.emit($event)"
  >
    <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.ARROW_LEFT" />
  </button>
</ng-template>

<div
  class="login-dialog login-dialog-open z5"
  [class.overlay]="overlay && !fullScreen"
  role="dialog"
  data-testid="login-dialog-container"
  fcomTrapFocus
>
  <div
    #loginContainer
    [class.grow]="fullScreen"
    [ngClass]="{ 'rounded-large elevation-level-1': !fullScreen }"
    class="content-container scroll"
    clickOutsideException="fin-login-form-container"
    (fcomClickOutside)="closeClicked.emit($event)"
    data-testid="login-form-container-content-root"
    [style.--login-dialog-top.px]="dialogTopOffsetPx()"
  >
    <div
      class="dialog-header white-bg surface-primary ps-medium-x ps-medium-t ps-xsmall-b align-left"
      [ngClass]="{ 'nordic-blue-900-bg surface-contrast white-text text-icon-reversed': invertHeaderColors }"
    >
      <div *finLet="stepperSteps$ | async as steps" class="flex flex--space-between">
        <button
          *ngIf="showLeftIcon && steps; else emptyIcon"
          [attr.aria-label]="'actions.back' | finLocalization"
          [attr.title]="'actions.back' | finLocalization"
          (click)="returnClicked.emit($event)"
        >
          <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.CHEVRON_LEFT" />
        </button>
        <fcom-stepper
          *ngIf="steps; else showIcon"
          class="inline-block"
          [showLabels]="false"
          [steps]="steps"
          [theme]="StepperTheme.DARK"
          [activeStep]="stepperActiveStep$ | async"
          (clicked)="stepperClicked.emit($event)"
        />
        <button
          *ngIf="closable"
          class="float-right"
          [class.nordic-blue-900-text]="!invertHeaderColors"
          [class.text-icon-primary]="!invertHeaderColors"
          [attr.aria-label]="'actions.close' | finLocalization"
          [attr.title]="'actions.close' | finLocalization"
          (click)="closeClicked.emit($event)"
        >
          <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.CLOSE_DELETE" />
        </button>
      </div>

      <h1
        [ngClass]="fullScreen ? 'font-heading-2 font-headline-medium' : 'font-heading-4 font-title-medium'"
        class="dialog-title ps-medium-t"
        #dialogTitle
        tabindex="-1"
      >
        {{ title | finLocalization }}
      </h1>

      <div aria-live="assertive">
        <fcom-notification
          *ngIf="error"
          data-testid="login-error-notification"
          class="mr-small-t"
          [title]="notificationTitle"
          [theme]="NotificationTheme.ALERT"
          [buttonStyle]="NotificationButtonStyle.LINK"
          [linkText]="errorLinkText"
          (linkClick)="alertNotificationLinkClicked.emit($event)"
        >
          <!--
            Sonar S1082 (click without keyboard equivalent) is a false positive here.
            This span is not an interactive control; it is an event-delegation host for the
            native <a> tags rendered via [innerHTML]. Those anchors are already keyboard
            accessible: pressing Enter on a focused link dispatches a real click that bubbles
            up to this handler, so no separate keyboard listener is needed. Marked as a false
            positive in Sonar rather than silenced with a redundant keydown handler.
          -->
          <span
            class="error-content font-body-1 font-body-medium"
            [innerHTML]="error | finSafe: 'html'"
            (click)="onMarkupErrorContentClick($event)"
          ></span>
        </fcom-notification>
      </div>

      <ng-content select=".header-notification" />

      <div
        class="description font-body-1 ms-large-t font-body-medium"
        [class.ms-medium-b]="!compact"
        [innerHTML]="description"
      ></div>

      <ng-content select=".header-content" />
    </div>
    <div
      class="dialog-content white-bg surface-primary align-left font-body-1 medium-type font-label-medium"
      [ngClass]="{ 'ps-medium-x ps-medium-b ps-medium-t': !compact }"
    >
      <ng-content />
    </div>
  </div>
</div>
